var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheikh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#008000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    id: "muslim",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,46a13,13,0,0,1-.13-26h0a1,1,0,0,1,.46,1.89A8,8,0,1,0,43.11,32.66a1,1,0,0,1,1.13-.51,1,1,0,0,1,.76,1A13.05,13.05,0,0,1,32,46ZM28.26,22.66A11,11,0,1,0,42.34,36.74,10,10,0,0,1,28.26,22.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38,32a1,1,0,0,1-1-1,3,3,0,0,0-3-3,1,1,0,0,1,0-2,3,3,0,0,0,3-3,1,1,0,0,1,2,0,3,3,0,0,0,3,3,1,1,0,0,1,0,2,3,3,0,0,0-3,3A1,1,0,0,1,38,32Zm-1-5a5.26,5.26,0,0,1,1,1,5.26,5.26,0,0,1,1-1,5.26,5.26,0,0,1-1-1A5.26,5.26,0,0,1,37,27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32,58.46a1,1,0,0,1-.71-.3L24.13,51H14a1,1,0,0,1-1-1V39.87L5.84,32.71a1,1,0,0,1,0-1.42L13,24.13V14a1,1,0,0,1,1-1H24.13l7.16-7.16a1,1,0,0,1,1.42,0L39.87,13H50a1,1,0,0,1,1,1V24.13l7.16,7.16a1,1,0,0,1,0,1.42L51,39.87V50a1,1,0,0,1-1,1H39.87l-7.16,7.16A1,1,0,0,1,32,58.46ZM15,49h9.54a1,1,0,0,1,.71.29L32,56l6.75-6.75a1,1,0,0,1,.71-.29H49V39.46a1,1,0,0,1,.29-.71L56,32l-6.75-6.75a1,1,0,0,1-.29-.71V15H39.46a1,1,0,0,1-.71-.29L32,8l-6.75,6.75a1,1,0,0,1-.71.29H15v9.54a1,1,0,0,1-.29.71L8,32l6.75,6.75a1,1,0,0,1,.29.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheikh);
export default __webpack_public_path__ + "static/media/Sheikh.9b220a70cdb24a70a3ba586781f1c941.svg";
export { ForwardRef as ReactComponent };